<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.663 14.75a.833.833 0 0 0 1.178.011l4.243-4.166a.833.833 0 0 0 0-1.19L13.84 5.24a.833.833 0 1 0-1.167 1.189l2.788 2.739H2.5a.833.833 0 1 0 0 1.666h12.962l-2.788 2.74a.833.833 0 0 0-.011 1.178z"
      fill="#1A202C"
    />
  </svg>
</template>
